"use strict";

var _interopRequireDefault = require("/home/runner/work/ap-cn-sfe-fe-pc/ap-cn-sfe-fe-pc/app/node_modules/@babel/runtime/helpers/interopRequireDefault.js");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _toConsumableArray2 = _interopRequireDefault(require("/home/runner/work/ap-cn-sfe-fe-pc/ap-cn-sfe-fe-pc/app/node_modules/@babel/runtime-corejs2/helpers/toConsumableArray.js"));
require("core-js/modules/web.dom.iterable");
var _axios = _interopRequireDefault(require("axios"));
var _validate = require("@/utils/validate");
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
var _default = exports.default = {
  data: function data() {
    var _this = this;
    var validateLoginCode = function validateLoginCode(rule, value, callback) {
      if ((0, _validate.validRule3)(value)) {
        callback(new Error(_this.$t('sysUser.error.loginCode')));
      } else if (_this.errorKeys.indexOf('loginCode') >= 0) {
        callback(new Error(_this.errorInfo['loginCode']));
        _this.resetError('loginCode');
      } else {
        callback();
      }
    };
    var validateExtOne = function validateExtOne(rule, value, callback) {
      if (_this.form.userClassification === 'S001002' && !value) {
        callback(new Error(_this.$t('sysUser.error.extOne')));
      } else {
        callback();
      }
    };
    var validateUserName = function validateUserName(rule, value, callback) {
      if ((0, _validate.validRule1)(value)) {
        callback(new Error(_this.$t('sysUser.error.userName')));
      } else if (_this.errorKeys.indexOf('userName') >= 0) {
        callback(new Error(_this.errorInfo['userName']));
        _this.resetError('userName');
      } else {
        callback();
      }
    };
    var validateUserMobile = function validateUserMobile(rule, value, callback) {
      if (!value) {
        callback();
      }
      if ((0, _validate.validPhone)(value)) {
        callback(new Error(_this.$t('sysUser.error.userMobile')));
      } else if (_this.errorKeys.indexOf('userMobile') >= 0) {
        callback(new Error(_this.errorInfo['userMobile']));
        _this.resetError('userMobile');
      } else {
        callback();
      }
    };
    var validateUserEmail = function validateUserEmail(rule, value, callback) {
      if (!value) {
        callback();
      }
      if ((0, _validate.validEmail)(value)) {
        callback(new Error(_this.$t('sysUser.error.userEmail')));
      } else if (_this.errorKeys.indexOf('userEmail') >= 0) {
        callback(new Error(_this.errorInfo['userEmail']));
        _this.resetError('userEmail');
      } else {
        callback();
      }
    };
    return {
      pageName: 'sysuser',
      formLabelWidth: '120px',
      loadingComponent: null,
      listLoading: false,
      isLoading: false,
      list: [],
      total: 0,
      currentId: null,
      isShowModel: false,
      currPage: 1,
      limit: 10,
      sourceApi: null,
      searchVal: {
        userName: '',
        userClassification: ''
      },
      dialogStatus: 'create',
      form: {
        userPk: '',
        loginCode: '',
        loginModule: '',
        userClassification: '',
        extOne: null,
        userName: '',
        userMobile: '',
        userEmail: '',
        remark: ''
      },
      initForm: {
        userPk: '',
        loginCode: '',
        loginModule: '',
        userClassification: '',
        extOne: null,
        userName: '',
        userMobile: '',
        userEmail: '',
        remark: ''
      },
      rules: {
        loginCode: [{
          required: true,
          trigger: ['change'],
          validator: validateLoginCode
        }],
        loginModule: [{
          required: true,
          trigger: ['change'],
          message: this.$t('sysUser.error.loginModule')
        }],
        userClassification: [{
          required: true,
          trigger: ['change'],
          message: this.$t('sysUser.error.userClassification')
        }],
        extOne: [{
          required: false,
          trigger: ['change'],
          validator: validateExtOne
        }],
        userName: [{
          required: true,
          trigger: ['change'],
          validator: validateUserName
        }],
        userMobile: [{
          required: false,
          trigger: ['change'],
          validator: validateUserMobile
        }],
        userEmail: [{
          required: false,
          trigger: ['change'],
          validator: validateUserEmail
        }]
      },
      errorKeys: [],
      errorInfo: {},
      loginModuleOptions: [],
      userClassificationOptions: [],
      extOneOptions: [],
      formatterLoginModuleOptions: {},
      formatterUserClassificationOptions: {},
      isShowRoleAuthModel: false,
      roleData: [],
      roleCheckList: [],
      initRoleCheckList: []
    };
  },
  computed: {
    stateBtn: function stateBtn() {
      return function (state) {
        if (state.toLowerCase() === 'enable') {
          state = 'disabled';
        } else {
          state = 'enable';
        }
        return this.$t("common.".concat(state));
      };
    }
  },
  watch: {
    isLoading: function isLoading(newValue) {
      // pc unlock 锁屏会导致页面晃动
      if (newValue) {
        this.loadingComponent = this.$loading({
          // lock: true,
          text: 'Loading',
          spinner: 'el-icon-loading',
          background: 'rgba(255, 255, 255, 0)'
        });
      } else {
        if (this.loadingComponent) {
          this.loadingComponent.close();
        }
      }
    }
  },
  mounted: function mounted() {
    this.fetchData();
    this.getLoginModule();
    this.getUserClassificationOptions();
  },
  methods: {
    tableIndex: function tableIndex(index) {
      return index + 1;
    },
    formatterLoginModule: function formatterLoginModule(row, column, cellValue, index) {
      return this.formatterLoginModuleOptions[cellValue] || cellValue;
    },
    formatterUserClassification: function formatterUserClassification(row, column, cellValue, index) {
      return this.formatterUserClassificationOptions[cellValue] || cellValue;
    },
    fetchData: function fetchData() {
      var _this2 = this;
      if (this.sourceApi) {
        this.sourceApi.cancel('cancel');
      }
      this.sourceApi = _axios.default.CancelToken.source();
      var param = {
        currPage: this.currPage,
        limit: this.limit,
        smodel: {
          userName: this.searchVal.userName,
          userClassification: this.searchVal.userClassification
        }
      };
      this.listLoading = true;
      this.$api.sysUser.getList(param, this.sourceApi.token).then(function (res) {
        _this2.listLoading = false;
        _this2.list = res.data.items;
        _this2.total = res.data.totalCount;
      }).catch(function (err) {
        if (_axios.default.isCancel(err)) {
          return false;
        }
        _this2.listLoading = false;
      });
    },
    searchData: function searchData() {
      this.currPage = 1;
      this.fetchData();
    },
    refreshData: function refreshData() {
      this.fetchData();
    },
    resetError: function resetError(val) {
      if (val) {
        var index = this.errorKeys.indexOf(val);
        this.errorKeys.splice(index, 1);
        delete this.errorInfo.val;
      } else {
        this.errorKeys = [];
        this.errorInfo = {};
      }
    },
    create: function create() {
      var _this3 = this;
      this.dialogStatus = 'create';
      this.form = {
        userPk: '',
        loginCode: '',
        loginModule: '',
        userClassification: '',
        extOne: null,
        userName: '',
        userMobile: '',
        userEmail: '',
        remark: ''
      };
      this.initForm = {
        userPk: '',
        loginCode: '',
        loginModule: '',
        userClassification: '',
        extOne: null,
        userName: '',
        userMobile: '',
        userEmail: '',
        remark: ''
      };
      if (this.loginModuleOptions.length > 0 && this.userClassificationOptions.length > 0) {
        this.isShowModel = true;
        this.$nextTick(function () {
          _this3.$refs['dataForm'].clearValidate();
        });
      } else {
        this.getLoginModule().then(function (res) {
          _this3.getUserClassificationOptions().then(function (res) {
            _this3.isShowModel = true;
            _this3.$nextTick(function () {
              _this3.$refs['dataForm'].clearValidate();
            });
          });
        });
      }
    },
    edit: function edit(row) {
      var _this4 = this;
      this.dialogStatus = 'edit';
      this.currentId = row.userPk;
      if (this.currentId === null) {
        return;
      }
      this.getDetail().then(function (res) {
        _this4.isShowModel = true;
        _this4.$nextTick(function () {
          _this4.$refs['dataForm'].clearValidate();
        });
      });
    },
    getLoginModule: function getLoginModule() {
      var _this5 = this;
      return new Promise(function (resolve) {
        _this5.$api.lookup.getLookupTypeCodeDetail('LPT_USER_MODULE').then(function (res) {
          _this5.loginModuleOptions = res.data;
          _this5.formatterLoginModuleOptions = {};
          if (res.data && res.data.length > 0) {
            res.data.forEach(function (item) {
              _this5.formatterLoginModuleOptions[item.valueCode] = item.valueName;
            });
          }
          resolve(_this5.form);
        }).catch(function () {
          console.log('Data Request Fail');
        });
      });
    },
    getUserClassificationOptions: function getUserClassificationOptions() {
      var _this6 = this;
      return new Promise(function (resolve) {
        var param = {
          currPage: 1,
          limit: 10000,
          smodel: {}
        };
        _this6.$api.userClassification.getUserClassificationList(param)
        // this.$api.userClassification.queryUserClassification(param)
        .then(function (res) {
          _this6.userClassificationOptions = [];
          _this6.formatterUserClassificationOptions = {};
          res.data.items.forEach(function (item) {
            var clfCode = item.clfCode,
              clfName = item.clfName;
            _this6.userClassificationOptions.push({
              valueCode: clfCode,
              valueName: clfName
            });
            _this6.formatterUserClassificationOptions[clfCode] = clfName;
          });
          resolve(_this6.form);
        }).catch(function () {
          console.log('Data Request Fail');
        });
      });
    },
    extOneReset: function extOneReset() {
      this.form.extOne = null;
    },
    getDetail: function getDetail() {
      var _this7 = this;
      return new Promise(function (resolve) {
        _this7.isLoading = true;
        _this7.$api.sysUser.getDetail(_this7.currentId).then(function (res) {
          _this7.isLoading = false;
          var _res$data = res.data,
            userPk = _res$data.userPk,
            loginCode = _res$data.loginCode,
            loginModule = _res$data.loginModule,
            userClassification = _res$data.userClassification,
            extOne = _res$data.extOne,
            userName = _res$data.userName,
            userMobile = _res$data.userMobile,
            userEmail = _res$data.userEmail,
            remark = _res$data.remark;
          _this7.form = {
            userPk: userPk,
            loginCode: loginCode,
            loginModule: loginModule,
            userClassification: userClassification,
            extOne: extOne,
            userName: userName,
            userMobile: userMobile,
            userEmail: userEmail,
            remark: remark
          };
          _this7.initForm = {
            userPk: userPk,
            loginCode: loginCode,
            loginModule: loginModule,
            userClassification: userClassification,
            extOne: extOne,
            userName: userName,
            userMobile: userMobile,
            userEmail: userEmail,
            remark: remark
          };
          resolve(_this7.form);
        }).catch(function () {
          _this7.isLoading = false;
          console.log('Data Request Fail');
        });
      });
    },
    switchState: function switchState(row, index) {
      var _this8 = this;
      if (row.state.toLowerCase() === 'enable') {
        this.$confirm(this.$t('common.confirm5'), this.$t('common.tip'), {
          confirmButtonText: this.$t('common.confirm'),
          cancelButtonText: this.$t('common.cancel'),
          type: 'warning'
        }).then(function () {
          _this8.isLoading = true;
          _this8.$api.sysUser.disabledItem(row.userPk).then(function (res) {
            _this8.$set(_this8.list[index], 'state', 'DISABLED');
            _this8.isLoading = false;
          }).catch(function () {
            // this.$message.error('删除失败')
            _this8.isLoading = false;
          });
        }).catch(function () {});
      } else {
        this.$confirm(this.$t('common.confirm6'), this.$t('common.tip'), {
          confirmButtonText: this.$t('common.confirm'),
          cancelButtonText: this.$t('common.cancel'),
          type: 'warning'
        }).then(function () {
          _this8.isLoading = true;
          _this8.$api.sysUser.enableItem(row.userPk).then(function (res) {
            _this8.$set(_this8.list[index], 'state', 'ENABLE');
            _this8.isLoading = false;
          }).catch(function () {
            // this.$message.error('删除失败')
            _this8.isLoading = false;
          });
        }).catch(function () {});
      }
    },
    deleteItem: function deleteItem(row) {
      var _this9 = this;
      this.$confirm(this.$t('common.confirm1'), this.$t('common.tip'), {
        confirmButtonText: this.$t('common.confirm'),
        cancelButtonText: this.$t('common.cancel'),
        type: 'warning'
      }).then(function () {
        _this9.isLoading = true;
        _this9.$api.sysUser.deleteItem([row.userPk]).then(function (res) {
          _this9.isLoading = false;
          _this9.refreshData();
        }).catch(function () {
          _this9.isLoading = false;
        });
      }).catch(function () {});
    },
    saveItem: function saveItem() {
      var _this0 = this;
      this.$refs['dataForm'].clearValidate();
      this.$refs.dataForm.validate(function (valid) {
        if (!valid) return;
        _this0.isLoading = true;
        _this0.$api.sysUser.saveItem(_this0.form).then(function (res) {
          _this0.isLoading = false;
          _this0.isShowModel = false;
          _this0.refreshData();
        }).catch(function (err) {
          if (err.errorInfos && err.errorInfos.length > 0) {
            _this0.resetError();
            err.errorInfos.forEach(function (item) {
              _this0.errorKeys.push(item.key);
              _this0.errorInfo[item.key] = item.errMsg;
            });
            _this0.$refs['dataForm'].validate(function (valid) {
              console.log(valid);
            });
          }
          _this0.isLoading = false;
          // this.$message.error('保存失败')
        });
      });
    },
    resetPassword: function resetPassword(row) {
      var _this1 = this;
      this.$confirm(this.$t('common.confirm12'), this.$t('common.tip'), {
        confirmButtonText: this.$t('common.confirm'),
        cancelButtonText: this.$t('common.cancel'),
        type: 'warning'
      }).then(function () {
        _this1.isLoading = true;
        _this1.$api.sysUser.passReset([row.userPk]).then(function (res) {
          _this1.isLoading = false;
        }).catch(function () {
          _this1.isLoading = false;
          // this.$message.error('删除失败')
        });
      }).catch(function () {});
    },
    roleAuth: function roleAuth(row) {
      var _this10 = this;
      this.dialogStatus = 'roleAuth';
      this.currentId = row.userPk;
      if (this.currentId === null) {
        return;
      }
      this.getAuthDetail().then(function (res) {
        _this10.isShowRoleAuthModel = true;
        _this10.$nextTick(function () {
          _this10.roleData.forEach(function (item) {
            if (item.checked === 'Y') {
              _this10.roleCheckList.push(item.roleKey);
              _this10.initRoleCheckList.push(item.roleKey);
              _this10.$refs.roleTable.toggleRowSelection(item, true);
            } else {
              _this10.$refs.roleTable.toggleRowSelection(item, false);
            }
          });
        });
      });
    },
    checkAuthDetail: function checkAuthDetail(row) {
      var _this11 = this;
      this.dialogStatus = 'checkAuthDetail';
      this.currentId = row.userPk;
      if (this.currentId === null) {
        return;
      }
      this.getAuthDetail().then(function (res) {
        _this11.isShowRoleAuthModel = true;
        _this11.$nextTick(function () {
          _this11.roleData.forEach(function (item) {
            if (item.checked === 'Y') {
              _this11.roleCheckList.push(item.roleKey);
              _this11.initRoleCheckList.push(item.roleKey);
              _this11.$refs.roleTable.toggleRowSelection(item, true);
            } else {
              _this11.$refs.roleTable.toggleRowSelection(item, false);
            }
          });
        });
      });
    },
    getAuthDetail: function getAuthDetail() {
      var _this12 = this;
      return new Promise(function (resolve) {
        _this12.isLoading = true;
        _this12.$api.role.roleInfoDetail(_this12.currentId).then(function (res) {
          _this12.isLoading = false;
          _this12.roleData = (0, _toConsumableArray2.default)(res.data);
          _this12.roleCheckList = [];
          _this12.initRoleCheckList = [];
          resolve(_this12.roleData);
        }).catch(function () {
          _this12.isLoading = false;
          console.log('Data Request Fail');
        });
      });
    },
    saveRoleAuthItem: function saveRoleAuthItem() {
      var _this13 = this;
      this.isLoading = true;
      this.$api.role.roleInfoSave({
        userPk: this.currentId,
        roleIds: this.roleCheckList
      }).then(function (res) {
        _this13.isLoading = false;
        _this13.isShowRoleAuthModel = false;
      }).catch(function () {
        _this13.isLoading = false;
        // this.$message.error('保存失败')
      });
    },
    getRoleKeys: function getRoleKeys(row) {
      return row.roleKey; // id为列表数据的唯一标识
    },
    handleRoleChange: function handleRoleChange(val) {
      var _this14 = this;
      this.roleCheckList = [];
      val.forEach(function (element) {
        _this14.roleCheckList.push(element.roleKey);
      });
    },
    checkSelectable: function checkSelectable() {
      if (this.dialogStatus === 'checkAuthDetail') {
        return false;
      } else {
        return true;
      }
    }
  }
};